module.exports = __webpack_public_path__ + "static/media/y-icon.17b7ec04.svg";